<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card :loading="loading" flat>
        <list-card-header
          v-model="checkAll"
          :count="(pagination && pagination.total) || 0"
          :is-loading="loading"
          :qr-card="list.filter((item) => item.checkbox)"
          :show-check="showCheck"
          @check="changeCheckAll"
          @emit-loading="loading = $event"
          @pause-sel="pauseSelected"
          @history-change="historyChange"
          @tag-change="TagChange"
        >
          <template v-slot:extension>
            <v-card flat max-width="150">
              <div class="rowinfo">
                <v-select
                  v-model="computedPerPage"
                  :items="['10', '25', '50', '100', '200', '400', '1000']"
                  :menu-props="{ offsetY: true }"
                  class="ma-2 my-md-0"
                  dense
                  hide-details
                  label="تعداد نمایش"
                  outlined
                  @change="onPerPage"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedPerPage`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="تعداد نمایش"
                />
              </div>
            </v-card>

            <v-menu
              :close-on-content-click="false"
              bottom
              offset-y
              open-on-hover
            >
              <template v-slot:activator="{ on, attr }">
                <v-btn
                  class="btn-management ma-0"
                  depressed
                  v-bind="attr"
                  v-on="on"
                >
                  <v-icon left>mdi-cogs</v-icon>
                  مدیریت مانیتورینگ
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group v-model="settings" multiple>
                  <template v-for="(item, i) in manageItems">
                    <v-list-item
                      :key="i"
                      :disabled="item.disabled()"
                      dense
                      @click="item.handler()"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action class="ml-2">
                          <v-checkbox
                            :input-value="active"
                            dense
                            hide-details
                            readonly
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.text" />
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <v-spacer />

            <v-card class="py-1 px-4 me-3 justify-end" outlined>
              <v-switch v-model="inRobot" class="ma-0" hide-details label="tt1">
                <template v-slot:label>
                  <span class="primary--text mb-n2">نمایش کیوآر tt1</span>
                </template>
              </v-switch>
            </v-card>
          </template>
        </list-card-header>

        <v-row class="px-6" no-gutters>
          <template v-if="!tableView">
            <v-col v-for="(x, i) in list" :key="i" class="mb-4" cols="12">
              <card-monitoring
                v-model="x.checkbox"
                :info="x"
                :price-loading="priceLoading"
                :show-check="showCheck"
                v-bind="listAttrs"
                @fetch="fetchData"
                @print-qr="printQr"
              />
            </v-col>
          </template>

          <v-col
            v-else-if="pagination && pagination.data"
            class="px-4"
            cols="12"
          >
            <vue-table
              v-model="selectedRows"
              :data="pagination"
              :headers="headers"
              :per-page.sync="computedPerPage"
              item-key="id"
              show-select
              @change="onPagination"
            >
              <template v-slot:type="{ item }">
                <template v-if="getQrTypes(item.type)">
                  <v-icon>mdi-{{ getQrTypes(item.type)?.icon }}</v-icon>
                  {{ getQrTypes(item.type)?.name || "-" }}
                </template>
              </template>

              <template v-slot:link="{ item }">
                {{ displayLink(item.domain?.name || "" + item.identifier) }}
              </template>

              <template v-slot:clicks="{ item }">
                <span>{{ item.clicks || 0 }}</span>
              </template>

              <template v-slot:prices="{ item }">
                {{
                  item.prices && item.prices.length > 0
                    ? item.prices[0].expire_at_days + " روز تا انقضا"
                    : " منقضی شده"
                }}
              </template>
            </vue-table>
          </v-col>
        </v-row>

        <pagination
          v-if="!tableView && pagination && pagination.data"
          ref="pagination"
          :data="pagination"
          @page="onPagination"
        >
          <template v-slot:per-page>
            <v-select
              v-model="computedPerPage"
              :items="[10, 25, 50, 100, 200]"
              :menu-props="{ offsetY: true }"
              class="ma-2 my-md-0"
              dense
              label="تعداد نمایش"
              outlined
              @change="onPerPage"
            />
          </template>
        </pagination>

        <v-card
          v-if="
            !loading &&
            list.length <= 0 &&
            (!pagination || pagination.total <= 0)
          "
          class="d-flex align-center justify-center"
          flat
          height="300"
          width="100%"
        >
          <v-card-title class="justify-center text-center"
            >هیچ کیوآری برای نمایش وجود ندارد!</v-card-title
          >
        </v-card>

        <!--    <custom-popup v-model="showPrint" :cons="{title: 'پرینت کیوآر'}" max-width="50vw" hide-confirm>-->
        <print-page
          v-if="showPrint"
          v-model="info"
          description
          @close="
            () => {
              showPrint = false;
            }
          "
        />
        <!--    </custom-popup>-->

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-dialog-show-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :visit-name="info.title"
              @close="showDialog = false"
              :qr_id="info.qrId"
              :is-qrlink="['qrlink','clickyarseo'].includes(info.type.toLowerCase())"

            />
          </v-card>
        </custom-popup>

        <custom-popup
          v-model="openHistory"
          :cons="{ title: 'تاریخچه' }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-History-dial-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="تاریخچه"
            />
          </template>
          <v-card v-if="openHistory">
            <list-history :id="info.id" />
          </v-card>
        </custom-popup>
      </v-card>
      <custom-popup
        v-model="priceDial"
        :cons="{ title: 'تمدید کیوآر' }"
        hide-confirm
        max-width="500"
        transition="dialog-bottom-transition"
        @close="
          itemdate = null;
          tempItemDate = null;
          priceDial = false;
          discountField = { show: false, model: '' };
        "
      >
        <div key="prices" class="pa-4">
          <custom-tabs
            style="
              width: 100%;
              max-width: 100%;
              min-width: 100%;
              margin-left: 2px;
              margin-right: 2px;
            "
            v-model="tabs"
            :tab-items="tabItems"
            :window-items="windowItems"
            fixed-tabs
          >
            <template v-slot:tab="{ tab }">
              {{ tab?.name || tab?.text || "-" }}
            </template>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                :element-name="`${serviceName}-${componentName}-data-${
                  tab?.name || 'vv'
                }-price-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="` ${tab?.name || tab?.text || ''}`"
              />
            </template>
            <template v-slot:item="{ item }">
              <div v-if="!!item?.value && item?.value === 'datatimes'">
                <!-- <set-date
                  :item="{ ...item, qrId: info.id }"
                  @update:item="updateWindowItem"
                /> -->
                <v-row no-gutters>
                  <!-- <v-col class="pa-2" cols="12" md="8">
                    <custom-date-picker-new
                      format="datetime"
                      :key="`date-picker-${info.id}`"
                      label="تاریخ انقضا"
                      outlined
                      input-class="date-end"
                      dense
                      :qr-id="info.id"
                      @close="priceDial = false"
                    /> -->
                  <!-- <custom-date-picker-new
                      v-model="tempItemDate"
                      format="datetime"
                      :key="`date-picker-${info.id}`"
                      label="تاریخ انقضا"
                      outlined
                      input-class="date-end"
                      dense
                      :auto-submit="false"
                      @input="updateTempItemDate"
                      :id="info.Id"
                    /> -->
                  <!-- <v-col cols="12" class="pa-2">
                      <v-btn
                        class="rounded-pill btn-delete ma-0"
                        depressed
                        @click="
                          sendDateExpire({ date: tempItemDate, qrId: info.id })
                        "
                        :disabled="!tempItemDate"
                      >
                        افزودن تاریخ انقضا
                      </v-btn>
                    </v-col>
                    <span v-show="!tempItemDate" class="red--text"
                      >انتخاب تاریخ الزامی است.</span
                    >
                  </v-col> -->
                  <div
                    v-if="!!item?.value && item?.value === 'datatimes'"
                    style="padding-top: 1px"
                  >
                    <set-expire-date
                      :qr-id="info.id"
                      @close="
                        priceDial = false;
                        fetchData();
                      "
                      @submit="updateLocalList"
                    />
                  </div>
                </v-row>
              </div>

              <v-list-item
                v-else
                class="overflow-hidden border pa-2 rounded mt-2"
              >
                <v-list-item-icon class="position-relative align-self-center">
                  <div
                    class="border border-2 rounded-circle position-absolute p-6"
                    style="top: 50%; transform: translateY(-50%); right: -4em"
                  >
                    <v-icon size="70">mdi-qrcode-scan</v-icon>
                  </div>
                </v-list-item-icon>

                <v-list-item-content class="ms-4">
                  <v-list-item-title>
                    <h3>
                      <v-icon color="amber">mdi-clock</v-icon>
                      {{ item.time | currency }}
                      <small>روزه</small>
                    </h3>

                    <h3 class="d-flex align-center">
                      <v-icon color="amber darken-3">mdi-wallet</v-icon>
                      <div class="d-inline-block mr-1">
                        <span
                          :class="
                            !!item.discount
                              ? 'text-decoration-line-through grey--text d-inline-block mb-1'
                              : ''
                          "
                        >
                          {{ item.price | currency }}
                          <v-chip
                            v-if="!!item.discount"
                            class="mr-2"
                            color="red"
                            dark
                            small
                          >
                            {{ item.discount }} %
                          </v-chip>
                        </span>
                        <template v-if="!!item.discount">
                          <br />
                          {{ computedDiscount(item) | currency }}
                        </template>
                        <small>﷼</small>
                      </div>
                    </h3>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    :disabled="discountField.show"
                    :loading="priceLoading"
                    color="green lighten-2"
                    @click="upgradeQr(item.id)"
                  >
                    خرید می‌کنم!
                  </v-btn>
                  <v-btn
                    :loading="priceLoading"
                    class="mt-2 mx-auto"
                    color="primary"
                    outlined
                    small
                    @click="
                      [
                        (discountField.show = !discountField.show),
                        (priceId = item.id),
                      ]
                    "
                  >
                    افزودن کد تخفیف
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </custom-tabs>
        </div>

        <v-expand-transition>
          <div v-if="discountField.show" key="discount">
            <v-card-title>استفاده از کد تخفیف ؟</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="discountField.model"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="کد تخفیف"
                outlined
                prepend-inner-icon="mdi-percent-box"
              >
                <template v-slot:append-outer>
                  <v-btn
                    :loading="priceLoading"
                    class="mt-n1"
                    color="green lighten-2"
                    dark
                    depressed
                    @click="upgradeQr(priceId)"
                  >
                    ثبت
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-text>
          </div>
        </v-expand-transition>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
// import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
// import customDatePickerNew from "../../content/custom-date-picker-new.vue";
// import CustomDatePicker from "@/view/content/custom-date-picker.vue";
import ListCardHeader from "./components/listCardHeader";
import pagination from "../../content/fragments/pagination";
import { mapActions, mapGetters } from "vuex";
import { debounce } from "@/main";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import CardMonitoring from "./components/cardList/cardMonitoring";
// import CustomDatePicker from "./components/cardList/custom-date-picker.vue";
import ListHistory from "./history/listHistory";
import SetExpireDate from "../../content/SetExpireDate.vue";
import PrintPage from "../../components/adapters/printPage";
import setDate from "./setDate";

export default {
  name: "qrMonitoring",

  components: {
    PrintPage,
    ListHistory,
    CardMonitoring,
    DownloadFileWithApi,
    pagination,
    ListCardHeader,
    setDate,
    // CustomDatePicker,
    // customDatePickerNew,
    SetExpireDate,
  },

  data() {
    return {
      user_tag: null,
      historyFilterVal: null,
      tempItemDate: null,
      itemdate: null,
      helpData: [],
      serviceName: "Qrland",
      componentName: "qrMonitoring",
      checked: [],
      checkAll: false,
      discountField: {
        show: false,
        model: "",
      },
      showPrint: false,
      inRobot: true,
      list: [],
      pagination: null,
      firstPage: false,
      page: 1,
      loading: false,
      settings: [],
      openHistory: false,
      manageItems: [],
      listAttrs: {
        images: false,
        settings: false,
        link: false,
      },
      tableView: false,
      cons: {
        title: "دانلود کیوآر",
      },
      qrTypes: {
        visitcard: "visitCard",
      },
      info: null,
      showDialog: false,
      priceDial: false,
      priceId: null,
      priceLoading: false,
      tabs: 0,
      prices: [],
      headers: [
        { text: "شناسه", value: "id" },
        { text: "نوع", value: "type" },
        { text: "عنوان", value: "title" },
        { text: "لینک", value: "link" },
        { text: "زمان ساخت", value: "created_at_diff" },
        { text: "بازدید", value: "clicks" },
        { text: "وضعیت", value: "prices" },
      ],
      selectedRows: [],
    };
  },

  mounted() {
    // this.$root.$on('fetchQrList', this.fetch)
    this.$root.$on("fillInfo", this.fillInfo);
    this.$root.$on("getPrices", this.getPrices);
    this.$root.$on("showHistory", this.showHistory);
    this.$nextTick(() => {
      if (!this.loading) {
        this.fetchData();
      }
    });

    this.manageItems = [
      {
        text: "نمایش جدولی",
        value: () => false,
        handler: this.showTable,
        disabled: () => false,
      },
      {
        text: "نمایش تصاویر",
        value: () => this.listAttrs.images,
        handler: () => (this.listAttrs.images = !this.listAttrs.images),
        disabled: () => this.tableView,
      },
      {
        text: "نمایش تنظیمات",
        value: () => this.listAttrs.settings,
        handler: () => (this.listAttrs.settings = !this.listAttrs.settings),
        disabled: () => this.tableView,
      },
      {
        text: "نمایش لینک",
        value: () => this.listAttrs.link,
        handler: () => (this.listAttrs.link = !this.listAttrs.link),
        disabled: () => this.tableView,
      },
    ];
  },

  computed: {
    ...mapGetters("localstorage", [
      "statusFilter",
      "typeFilter",
      "sortFilter",
      "searchTypeFilter",
      "userFilter",
      "expireTypeFilter",
      "perPageFilter",
      "identifierFilter",
      "idSearchFilter",
    ]),
    computedPerPage: {
      get() {
        return this.perPageFilter;
      },
      set(val) {
        this.updatePerPageFilter(val);
      },
    },
    // formattedParentDate() {
    //   return this.tempItemDate ? this.dateString(this.tempItemDate) : "";
    // },
    showCheck() {
      return this.checked.length > 0;
    },
    tabItems() {
      return this.ribbon_can("change_expire")
        ? //{
          [
            ...this.prices,
            {
              name: "تغییر تاریخ انقضا",
              value: "datatimes",
            },
          ]
        : // ? [...this.prices, { name: "تغییر تاریخ انقضا", value: "datatimes" }]
          this.prices;
    },
    windowItems() {
      return this.ribbon_can("change_expire")
        ? [
            ...this.prices,
            {
              name: "تغییر تاریخ انقضا",
              value: "datatimes",
            },
          ]
        : this.prices;
    },
    // return this.ribbon_can("change_expire")
    //   ? [...this.prices, { value: "datatimes", date: "" }]
    //   : this.prices;
    // },
  },

  watch: {
    itemdate(val) {
      console.log("itemdate changed to:", val);
    },
    priceDial(val, oldVal) {
      if (oldVal === true && val === false) {
        // console.log("counter-fetch");
        // this.fetchData();
      }
    },
    // tabs(val) {
    //   if (val === "datatimes") {
    //     this.$nextTick(() => {
    //       // if (!this.itemdate) {
    //       this.tempItemDate = this.itemdate || "";
    //       // }
    //     });
    //   }
    // },
    tabs(val) {
      console.log("Tabs changed to:", val);
      if (val === "datatimes") {
        this.$nextTick(() => {
          this.tempItemDate = this.itemdate || "";
        });
      }
    },
    "discountField.show"(val) {
      this.discountField.model = "";
    },
    tableView(val) {
      if (val) {
        let obj = this.pagination;
        this.pagination = null;
        this.$nextTick(() => {
          this.pagination = obj;
        });
      }
    },
    selectedRows(val) {
      let selected = val.map((item) => item.id);

      this.list.forEach((item) => {
        item.checkbox = selected.includes(item.id);
      });
    },
    checkAll(val) {
      if (val) {
        this.list.forEach((item) => {
          item.checkbox = true;
        });
      }
    },
    sortFilter(val) {
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    statusFilter(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    typeFilter(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    searchTypeFilter: {
      deep: true,

      handler(val) {
        this.firstPage = true;
        this.$nextTick(() => {
          this.fetchData();
        });
      },
    },
    identifierFilter(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    idSearchFilter(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    userFilter(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    expireTypeFilter: {
      deep: true,
      handler(val) {
        this.firstPage = true;
        this.$nextTick(() => {
          this.fetchData();
        });
      },
    },
    inRobot(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    computedPerPage(val) {
      this.firstPage = true;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
  },

  beforeRouteLeave(to, from, next) {
    this.resetStates();
    next();
  },

  methods: {
    // debouncedFetch: debounce(function () {
    //   this.firstPage = true;
    //   this.fetchData();
    // }, 300),
    historyChange(val) {
      this.historyFilterVal = val;
      this.firstPage = true; 
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    TagChange(val) {
      this.user_tag = val;
      this.firstPage = true; 
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    
    updateLocalList(qrId, expireDate, expire_at_days) {
      this.priceLoading = true;
      const index = this.list.findIndex((item) => item.id === qrId);
      if (index !== -1) {
        this.$set(this.list[index], "prices", [
          {
            expire_at: expireDate,
            expire_at_days: expire_at_days,
          },
        ]);
      }
      if (this.pagination && this.pagination.data) {
        const dataIndex = this.pagination.data.findIndex(
          (item) => item.id === qrId,
        );
        if (dataIndex !== -1) {
          this.$set(this.pagination.data[dataIndex], "prices", [
            {
              expire_at: expireDate,
              expire_at_days: expire_at_days,
            },
          ]);
        }
      }
      this.priceLoading = false;
      // this.$forceUpdate();
    },
    ...mapActions("localstorage", [
      "updatePerPageFilter",
      "resetStates",
      "updateHasError",
    ]),
    updateTempItemDate(val) {
      this.tempItemDate = val;
    },
    dateString(input) {
      if (!input) return "-";
      try {
        let moment = require("moment-jalaali");
        moment.loadPersian({ dialect: "persian-modern" });
        return (
          moment(input, "YYYY-M-D").format("dddd LL") +
          " ساعت " +
          moment(input).format("LT")
        );
      } catch (e) {
        console.error("Error in dateString:", e);
        return "-";
      }
    },
    // sendExpire(date){
    //   this.sendDateExpire({})
    // },
    sendDateExpire(item) {
      if (!item.date || item.date === "") {
        this.priceDial = false;
        return;
      }
      this.priceLoading = true;
      this.itemdate = item.date;
      this.$api
        .post(`/admin/change-expire/${item.qrId}`, {
          date: item.date,
        })
        .then(() => {
          this.$toast.success("تاریخ انقضا با موفقیت تغییر یافت.");
          this.priceDial = false;
          this.tempItemDate = null;
          this.itemdate = null;
          this.fetchData();
          // this.$nextTick(() => {
          //   if (!this.loading) {
          //     this.fetchData();
          //   }
          // });
        })
        .catch(({ response }) => {
          console.log("error in change expire date: ", response);
          this.$toast.error("خطا در تغییر تاریخ انقضا!");
        })
        .finally(() => {
          this.priceLoading = false;
        });
    },
    onPagination(page) {
      this.page = page;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    fetchData(
      filter = this.sortFilter,
      status = this.statusFilter,
      search = this.searchTypeFilter,
      type = this.typeFilter,
      idSearch = this.idSearchFilter,
      expireType = this.expireTypeFilter,
      identifier = this.identifierFilter,
    ) {
      // if (this.loading)
      //   return debounce(() => {
      //     this.loading = false;
      //     this.$nextTick(() => this.fetchData());
      //   }, 300);
      if (this.loading) return;

      this.loading = true;
      this.priceLoading = true;

      this.updateHasError(false);
      let p = {};

      // set filters
      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else p.sort = filter;

      if (status !== "all")
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else p.status = status;

      if (type !== "all") p.type = type;

      if (!!search && !!search.text && !!search.text.length)
        p.search = search.text;

      if (!!search && search.type !== "search" && !!search.text) p.from = 1;

      if (identifier && identifier.length >= 1) p.identifier = identifier;

      if (idSearch && idSearch.length >= 1) p.id = idSearch;

      if (!this.inRobot) p.robot = 1;

      if (this.userFilter) {
        p.user = this.userFilter;
      }
      if (expireType && expireType.expired_type && expireType.days !== null && expireType.days !== "") {
        p.expired_type = expireType.expired_type;
        p.days = expireType.days;
      }
      if (this.historyFilterVal && this.historyFilterVal !== 'all') {
        p.history = this.historyFilterVal;
      }
      p.page = this.page = this.firstPage ? 1 : this.page;
      p.length = this.computedPerPage;
      if(!!this.user_tag && this.user_tag !=='همه')
          p.user_tag = this.user_tag;
      // end filters

      this.$api
        .get("/admin/qr-list", {
          params: p,
          timeout: 50000,
        })
        .then(({ data }) => {
          if (this.unwatch) this.unwatch();
          this.pagination = data.data;
          // this.list = data.data.data;
          this.list = Object.freeze(data.data.data);
          this.firstPage = false;

          this.$nextTick(() => {
            this.checked = this.list
              .filter((item) => item.checkbox)
              .map((item) => "check-" + item.id);
            this.checkAll = this.checked.length >= this.list.length;
            this.unwatch = this.$watch(
              "list",
              (val) => {
                this.checked = val
                  .filter((item) => item.checkbox)
                  .map((item) => "check-" + item.id);
                this.checkAll = this.checked.length >= this.list.length;
              },
              { deep: true },
            );
          });
        })
        .catch(({ response }) => {
          console.log("has error: ", response);
          this.updateHasError(true);
        })
        .finally(() => {
          this.loading = false;
          this.priceLoading = false;
        });
    },
    changeCheckAll(value) {
      if (!value) {
        this.list.forEach((item) => {
          item.checkbox = false;
        });
      } else {
        this.$nextTick(() => {
          this.checked = this.list
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
        });
      }
    },
    pauseSelected(e) {
      this.loading = true;

      let identifier = this.list
        ?.filter((item) => item.checkbox)
        .map((item) => item.identifier);
      this.$api
        .post("/admin/change-status", {
          identifier: identifier,
          status: e,
        })
        .then(({ data }) => {
          this.fetchData();
          this.$toast.success("با موفقیت تغییر یافت.");
        })
        .catch(({ response }) => {
          this.$toast.error("خطایی رخ داده است!");
          console.log("error in change status all: ", response);
        })
        .finally(() => (this.loading = false));
    },
    getPrices(e) {
      this.info = e;
      this.priceLoading = true;
      let types = this.getQrTypes().map((item) => item.value);
      let index =
        types.findIndex(
          (item) => item.toLowerCase() === e.type.toLowerCase(),
        ) || -1;

      this.$api
        .get("user/price", {
          params: {
            type: types[index],
          },
        })
        .then((response) => {
          this.prices = response.data.data.sort((a, b) => a.time - b.time);
          this.priceDial = true;
        })
        .catch((reason) => {
          console.log(reason);
          this.$modal.error("خطا", "هیج تعرفه‌ای وجود ندارد!");
        })
        .finally(() => (this.priceLoading = false));
    },
    fillInfo(e) {
      this.info = e;
      this.showDialog = true;
    },
    showHistory(e) {
      this.info = e;
      this.openHistory = true;
    },
    upgradeQr(priceId) {
      this.priceLoading = true;

      this.$api
        .put(`user/price/upgrade/${this.info.id}/${priceId}`, {
          discount_code: !!this.discountField.model
            ? this.discountField.model
            : undefined,
        })
        .then((response) => {
          this.priceDial = false;

          this.$modal.success(
            this.$t("success"),
            this.$t("qr_upgraded_successfully"),
          );
          this.fetchData();
        })
        .catch((reason) => {
          console.log(reason);

          if (reason.response.status === 402)
            this.$modal.error("خطا", this.$t("check_account_balance"));
          else if (reason.response.status === 422)
            this.$modal.error("خطا",reason.response?.data?.message|| reason.response?.message || reason.response?.error?.message);
          else  this.$modal.error("خطا", "خطا در تمدید کیوآر!");
        })
        .finally(() => {
          this.priceLoading = false;
        });
    },
    showTable() {
      this.changedSelected([]);
      // this.listAttrs = {
      //   images: false,
      //   settings: false,
      //   link: false
      // }
      this.tableView = !this.tableView;
    },
    changedSelected(ids) {
      let l = this.list;
      this.list = [];
      if (this.unwatch) this.unwatch();

      this.$nextTick(() => {
        l.forEach((item) => {
          item.checkbox = ids.includes(item.id);
        });
        this.list = l;
      });

      this.unwatch = this.$watch(
        "list",
        (val) => {
          this.checked = val
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
          this.checkAll = this.checked.length >= this.list.length;
        },
        { deep: true },
      );
    },
    printQr(e) {
      this.info = e;
      this.showPrint = true;
    },
    computedDiscount(price) {
      let p = Math.floor((price.discount * price.price) / 100);

      return price.price - p;
    },
    displayLink(link) {
      let rgx = /^(http|https):\/\//gm;
      return this.info?.dest_link?? link?.replace(rgx, "");
    },
  },

  beforeDestroy() {
    // this.$root.$off('fetchQrList', this.fetch)
    this.$root.$off("fillInfo", this.fillInfo);
    this.$root.$off("getPrices", this.getPrices);
  },
};
</script>

<style scoped></style>
